<template>
  <v-dialog
      v-model="isShown"
      no-click-animation
      scrollable
      :overlay-color="isDarkTheme ? '#424242': 'overlaycolor'"
      overlay-opacity="0.3"
      transition="slide-x-reverse-transition"
      max-width="1080"
      persistent
      @click:outside="closeDialog()">
    <v-card
        flat
        tile
        class="mr-sm-15 overflow-md-y-hidden overflow-x-hidden px-0 px-md-12 pt-8 pb-0">
      <AddDeviceRunner v-if="$route.params.action === 'addDeviceRunner'"/>
      <CreateOperatorForm v-if="$route.params.action === 'addOperator' || $route.name === 'addOperator'" :progress="$route.params.progress"/>
      <CreateOperatorGroupForm v-if="$route.name === 'addOperatorGroup'"/>
      <DetectDevices v-if="$route.params.action === 'detectDevices'"/>
      <AddLocation 
      v-else-if="$route.params.action === 'addLocation'"/>
      <InviteUser v-if="$route.params.action === 'inviteUser'"/>
      <LocationInfoEdit
          v-else-if="
          $route.params.location_type === 'location' &&
          $route.params.uuid &&
          $route.params.action === 'edit'
        "/>
      <LocationInfo
          v-else-if="$route.params.location_type === 'location' && $route.params.uuid"
          type="location"
      />
      <DeviceInfoEdit
          v-else-if="
          ($route.params.device_type === 'device' &&
          $route.params.action === 'edit' &&
          $route.params.uuid) || ($route.params.monitoring_type === 'device' && $route.params.action === 'edit' && $route.params.uuid)"
      />
      <DeviceInfo
          v-else-if="$route.params.device_type === 'device' && 
          $route.params.uuid || $route.name === 'device_location' && 
          type === 'device'"
          type="device"
          :channel="channel"
      />
      <CameraInfo
          v-else-if="$route.params.device_type === 'camera' && 
          $route.params.uuid"
          type="camera"
      />  
      <MonitoringInfo
        v-else-if="$route.params.monitoring_type === 'device' && $route.params.uuid"
        type="device"
        :channel="channel"
      /> 
      <edit-group v-else-if="$route.params.action === 'edit' && this.$route.params.action === 'edit'"/>
      <AddGroup v-else-if="$route.params.action === 'addGroup'"></AddGroup>
    <GroupInfo type="group" v-else-if="this.route === 'group'"/>
    <OperatorView v-else-if="this.$route.name === 'viewOperator'"/>
    <OperatorGroupView v-else-if="this.$route.name === 'viewOperatorGroup'"/>
    <OperatorsEdit v-else-if="this.$route.name === 'editOperator'"/>
    <OperatorGroupEdit v-else-if="this.$route.name === 'editOperatorGroup'"/>
    <ResetOperatorCredentials v-else-if="this.$route.name === 'resetOperatorCredentials'"/>
    </v-card>
  </v-dialog>
</template>
<script>
import DeviceInfo from "./Devices/Device/DeviceInfo";
import AddGroup from "./Groups/AddGroups.vue";
import CameraInfo from "./Devices/Camera/CameraInfo";
import AddDeviceRunner from "./Devices/AddDeviceRunner";
import DetectDevices from "./Devices/DetectDevices";
import AddLocation from "./Locations/AddLocation";
import LocationInfo from "./Locations/LocationInfo";
import LocationInfoEdit from "./Locations/LocationInfoEdit";
import {mapActions, mapGetters} from "vuex";
import DeviceInfoEdit from "./Devices/Device/DeviceInfoEdit";
import InviteUser from "./Accounts/InviteUser";
import MonitoringInfo from "./Monitoring/MonitoringData/MonitoringInfo.vue";
import GroupInfo from './Groups/GroupInfo.vue';
import EditGroup from './Groups/EditGroup.vue';
import CreateOperatorForm from "./Accounts/CreateOperatorForm.vue";
import CreateOperatorGroupForm from "./Accounts/CreateOperatorGroupForm.vue";
import OperatorView from './Accounts/OperatorView.vue';
import OperatorGroupView from './Accounts/OperatorGroupView.vue';
import OperatorsEdit from "./Accounts/OperatorsEdit.vue";
import OperatorGroupEdit from "./Accounts/OperatorGroupEdit.vue";
import ResetOperatorCredentials from "./Accounts/ResetOperatorCredentials.vue";




const v4 = new RegExp(/^[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i);
const v5 = new RegExp(/^[0-9A-F]{8}-[0-9A-F]{4}-[5][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i);
export default {
  name: "FlyoutMenu",
  components: {
    InviteUser,
    DeviceInfoEdit,
    DeviceInfo,
    CameraInfo,
    LocationInfo,
    LocationInfoEdit,
    AddDeviceRunner,
    DetectDevices,
    AddLocation,
    MonitoringInfo,
    AddGroup,
    GroupInfo,
    EditGroup,
    CreateOperatorForm,
    CreateOperatorGroupForm,
    OperatorView,
    OperatorGroupView,
    OperatorsEdit,
    OperatorGroupEdit,
    ResetOperatorCredentials
  },
  data: () => ({
    channel: null,
    route: "",
    type: "",
  }),
  computed: {
    ...mapGetters("devices",["getFlyoutEditDevice", "getSelectedDevice"]),
    ...mapGetters("locations", ["getFlyoutEditLocation", "getSelectedLocation"]),
    isShown() {
      // Show dialog if action param is present, or if route is addAdministrator (inviteUser), or specific route names
      const operatorRoutes = ['addOperator', 'viewOperator', 'editOperator', 'addOperatorGroup', 'viewOperatorGroup', 'editOperatorGroup', 'resetOperatorCredentials'];
      const actionRoutes = ['accounts_action', 'location_action', 'device_action', 'group_action'];
      const deviceRoutes = ['activity_device', 'performance_device', 'device'];
      
      return !!this.$route.params.device_type || 
             !!this.$route.params.monitoring_type ||
             !!this.$route.params.action || 
             this.$route.name === 'addAdministrator' ||
             operatorRoutes.includes(this.$route.name) ||
             actionRoutes.includes(this.$route.name) ||
             deviceRoutes.includes(this.$route.name);
    },
    isDarkTheme() {
      return this.$vuetify.theme.dark || false;
    },
  },
  methods: {
    ...mapActions({
      getDevice: "devices/getSpecificDevice",
      getDevices: "devices/getDevices",
      getLocation: "locations/getLocationByUUID",
      addAlert: "global/addAlert",
      setSpace: "global/setSpace",
      getDisplays: "devices/getDeviceDisplays",
      getAvailableApps: "devices/getAvailableApplications",
      fetchGroup: "groups/fetchGroup"
    }),

     closeDialog() {
      if(this.$route.name === 'location' && this.$route.params.action === 'view'){
          this.$router.replace(`/locations`)
             if (localStorage.getItem("fromGroups")) {
              let nameFrom = localStorage.getItem('fromGroups');
              this.$router.replace(nameFrom);
              return;
            }
          }
      if(this.$route.name === 'device_location' && window.history.length === 2){
        this.$router.replace(`/locations`)
      }else if(this.$route.name === 'editOperator'){
        window.history.length > 1 ? this.$router.go(-1) : this.$router.replace(`/${this.$route.name}s`);
      }else if(this.$route.name === 'editOperatorGroup'){
        window.history.length > 1 ? this.$router.go(-1) : this.$router.replace(`/${this.$route.name}s`);
      }else if(this.$route.name === 'resetOperatorCredentials'){
        window.history.length > 1 ? this.$router.go(-1) : this.$router.replace('/operators');
      }

      if (
         this.$route.name === 'location' 
      || this.$route.name === 'device' 
      || this.$route.name === 'account' 
      || this.$route.name === 'device_location' 
      || this.$route.name === 'performance' 
      || this.$route.name === 'activity' 
      || this.$route.name === 'activity_device' 
      || this.$route.name === 'performance_device' 
      || this.$route.name === "group"
    ) {
        if (this.$route.params.fromLocation) {
          this.$router.replace(`/devices`)
        }else if(this.route === 'group'){
          this.$router.replace(`/groups`)
          this.$store.commit("groups/setGroup", '');
        }
        else if(this.$route.params.action === 'detectDevices'){
          this.$store.commit('locations/SET_DETECTED_DEVICES', []);
          this.$store.commit("devices/SET_NO_DETECT_DEVICES", false);
        } else {
          if (window.history.length > 2) {
            if((['general', 'peripherals', 'assetInfo', 'settings'].includes(this.$route.params.tab) && this.$route.name !== "device" && this.$route.params.action !== "edit")){
               if(this.$route.name === 'device_location'){
                this.$router.replace(`/locations/location/view/${this.getSelectedLocation.uuid}/${this.$route.params.tab}`)
              }else if(this.$route.name === 'activity_device'){
                this.$router.replace(`/activity`)
              }else if(this.$route.name === 'performance_device'){
                this.$router.replace(`/performance`)
              }else{
                 this.$router.replace(`/${this.$route.name}s`)
              }
            }if((['general', 'peripherals', 'assetInfo', 'settings'].includes(this.$route.params.tab) && this.$route.name === "device" && this.$route.params.action !== "edit")){
                 this.$router.replace(`/${this.$route.name}s`)
            }else if(this.$route.params.action === "edit"){
              this.$router.go(-1);
            }
            this.$store.commit('monitoring/SET_SELECTED_DEVICE', "");
          }else if(this.$route.name === 'device_location'){
            this.$router.replace(`/locations/location/view/${this.selectedItem.location_uuid}/devices`)
          } 
          else {
            if(this.$route.params.actions === 'edit' && this.$route.name === 'group'){
              this.$router.replace(`/${this.$route.name}`);
            }else if(this.$route.name === 'activity_device'){
              this.$router.replace(`/activity`);
            }else if(this.$route.name === 'performance_device'){
              this.$router.replace(`/performance`);
            }else{
              this.$router.replace(`/${this.$route.name}s`);
            }
          }
        }
        this.$store.commit('devices/SET_SELECTED_DEVICE', "");
        this.$store.commit('devices/SET_ACTIVE_PERIPHERAL', "");
        this.$store.commit('monitoring/SET_SELECTED_DEVICE', "");
      }
      if (this.$route.name === 'accounts_action' || 
          this.$route.name === 'location_action' || 
          this.$route.name === 'device_action' || 
          this.$route.name === 'devices_action' || 
          this.$route.name === 'group_action' || 
          this.$route.name === 'viewOperator' || 
          this.$route.name === 'addOperator' ||
          this.$route.name === 'addOperatorGroup' ||
          this.$route.name === 'viewOperatorGroup'
        ) {
        // For operator routes, navigate to the appropriate list page
        if (this.$route.name === 'addOperator' || this.$route.name === 'viewOperator') {
          this.$router.push('/operators');
        } else if (this.$route.name === 'addOperatorGroup' || this.$route.name === 'viewOperatorGroup') {
          this.$router.push('/operator-groups');
        } else if (this.$route.name === 'devices_action') {
          // Clean up detect devices state if needed
          this.$store.commit('locations/SET_DETECTED_DEVICES', []);
          this.$store.commit("devices/SET_NO_DETECT_DEVICES", false);
          this.$router.push('/devices');
        } else if (window.history.length > 0) {
          this.$router.go(-1);
        } 
      }

      this.$store.commit('devices/SET_SELECTED_DEVICE', "");
      this.$store.commit('monitoring/SET_SELECTED_DEVICE', "");
      this.$store.commit("devices/SET_LOADER_SCREENSHOT", false);      
      this.$store.commit("devices/SET_LOADER_RD", false);      
      this.$store.commit("devices/SET_LOADER_RSSH", false);
      this.$store.commit("devices/SET_LOADER_CONFTOOL", false);
      this.$store.commit("devices/SET_LOADER_TOUCHSCREENCALIBRATION", false);
      this.$store.commit("locations/SET_LOCATION_DEVICES", []);
      this.$store.commit("devices/SET_DEVICE_COMMENTS", {});
      if (this.channel) {
        this.channel.unbind();
        this.channel.unsubscribe();
        this.channel = null;
      }
    },
    handleDeviceDebugStatusNotification(data) {
      this.addAlert({
        type: data.severity === "error" ? "error" : "success",
        message: data.message,
      });

      const targetUuid = data.deviceUuid || this.getSelectedDevice?.uuid;
      if (!targetUuid) return;

      // 204 toggle has no body — always reload device for real debug_mode.
      this.getDevice({ route: "device", uuid: targetUuid });
    },
    subscribe(type, uuid) {
      const channelName = `${type}_${uuid}`;
      if (this.channel) {
        this.channel.unbind();
        // Keep subscription if same channel; only switch when device/location changes.
        if (this.channel.name !== channelName) {
          this.channel.unsubscribe();
          this.channel = this.$pusher.subscribe(channelName);
        }
      } else {
        this.channel = this.$pusher.subscribe(channelName);
      }
      if (type === "location") {
        this.channel.bind("locationDetailsUpdate", (data) => {
          switch (data.type) {
            case "devicesDetected":
            this.addAlert({
              type: "info",
              message: "Cameras detected",
            });
            break;
          case "noDevicesDetected":
            this.addAlert({
              type: "error",
              message: "Camera scan unavailable."
            })
            break;
          }
        });
      } else if (type === "device" || (this.route === 'device_location' && type === 'device') || this.route === 'monitoring' && (type === 'device')) {
        this.channel.bind("deviceDetailsUpdate", (data) => {
          switch (data.type) {
            case "screenshotNotification":
              this.addAlert({
                color: "overlaycolor",
                constant: true,
                message: "Screenshot taken",
                button: {
                  showCloseButton: true,
                  type: 'screenshot',
                  text: 'View',
                  data: data.screenshotUrl
                },
                linkType: 'screenshot'
              }).then(() => {
                this.$store.commit("devices/SET_LOADER_SCREENSHOT", false);
              })
              break;
            case "screenshotNotificationError":
            this.addAlert({
                  type: "error",
                  message: data.errorMessage,
                }).then(() => {
                this.$store.commit("devices/SET_LOADER_SCREENSHOT", false);
              });
              break;
            case "DDMConfNotification":
              if (data.severity === "error") {
                this.addAlert({
                  type: "error",
                  message: data.message,
                });
              }else if (data.severity === "normal") {
                this.addAlert({
                  type: "success",
                  message: data.message
                }).then(() => {
                    this.getDisplays(this.getSelectedDevice.uuid);
                    this.getAvailableApps(this.getSelectedDevice.uuid);
                })
              } else {
                return;
              }
              break;
            case "reverseSshNotification":
              this.addAlert({
                type: "success",
                color: "overlaycolor",
                constant: true,
                message: "RSSH Port: " + data.reverseSshPort,
                button: {
                  showCloseButton: true,
                  type: 'copy',
                  text: 'Copy',
                  data: data.reverseSshPort
                }
              }).then(() => {
                this.$store.commit("devices/SET_LOADER_RSSH", false);
              })
              break;
              case "reverseSshNotificationWindows":
              this.addAlert({
                type: "success",
                color: "overlaycolor",
                constant: true,
                message: "RSSH Port: " + data.reverseSshPort + "            Username:" + data.username,
                button: {
                  showCloseButton: true,
                  type: 'copy',
                  text: 'Copy',
                  data: data.reverseSshPort
                }
              }).then(() => {
                this.$store.commit("devices/SET_LOADER_RSSH", false);
              })
              break;
            case "remoteDesktopNotification":
              this.addAlert({
                type: "success",
                color: "overlaycolor",
                constant: true,
                button: {
                  showCloseButton: true,
                  type: 'open',
                  data: data.remoteDesktopUrl,
                  text: 'Connect'
                },
                message: "Remote Desktop available"
              }).then(() => {
                this.$store.commit("devices/SET_LOADER_RD", false);
                this.$store.commit("devices/SET_LOADER_VNC", false);
              })
              break;
            case "peripheralsDetected":
              this.addAlert({
                type: "success",
                message: "New peripherals detected."
              }).then(() => {
                let params = { route: 'device', uuid: this.getSelectedDevice.uuid };
                  this.getDevice(params).then(response =>{
                    let payload = {
                    "uuid": this.getSelectedDevice.uuid,
                    "data": response
                    };
                    this.$store.commit("devices/UPDATE_DEVICE_BY_UUID", payload);//update mutation 
                    this.getDisplays(this.getSelectedDevice.uuid);
                    this.getAvailableApps(this.getSelectedDevice.uuid);
                  })
                  })
              break;
            case "noPeripheralsDetected":
              this.addAlert({
                type: "warning",
                message: "No new peripherals detected."
              }).then(() => {
                let params = { route: 'device', uuid: this.getSelectedDevice.uuid };
                  this.getDevice(params).then(response =>{
                    let payload = {
                    "uuid": this.getSelectedDevice.uuid,
                    "data": response
                    };
                    this.$store.commit("devices/UPDATE_DEVICE_BY_UUID", payload);//update mutation 
                    this.getDisplays(this.getSelectedDevice.uuid);
                    this.getAvailableApps(this.getSelectedDevice.uuid);
                  })
              })
              break;
            case "displaysDetected":
              this.getDisplays(this.getSelectedDevice.uuid);
              break;
            case "noDisplaysDetected":
              this.addAlert({
                type: "warning",
                message: "No new displays detected."
              }).then(() => {
                let params = { route: 'device', uuid: this.getSelectedDevice.uuid };
                  this.getDevice(params).then(response =>{
                    let payload = {
                    "uuid": this.getSelectedDevice.uuid,
                    "data": response
                    };
                    this.$store.commit("devices/UPDATE_DEVICE_BY_UUID", payload);//update mutation 
                    this.getDisplays(this.getSelectedDevice.uuid);
                    this.getAvailableApps(this.getSelectedDevice.uuid);
                  })
              })

              break;
            case "offlineDeviceUpdated":
              this.addAlert({
                type: "warning",
                message: "Configuration updated, but device is offline",
              });
              break;
            case "deviceDisabled":
              this.addAlert({
                type: "error",
                message: "Device is disabled.",
              });
              break;
            case "noAvailableAppRunners":
              this.addAlert({
                type: "error",
                message: "Device has no app runners available."
              });
              break;
            case "nonInstalledDevice":
              this.addAlert({
                type: "error",
                message: "Action failed. Device not installed."
              });
              break;
            case "fullTelemetryUpdated":
            {
              let params = { route: 'device', uuid: this.getSelectedDevice.uuid };
              this.getDevice(params).then(response =>{
                let payload = {
                "uuid": this.getSelectedDevice.uuid,
                "data": response
                };
                this.$store.commit("devices/UPDATE_DEVICE_BY_UUID", payload);//update mutation 
              })
              break;
            }
            case "visionWorkersEnabledStatusNotification": {
              this.addAlert({
                type: data.severity === 'error' ? 'error' : 'success',
                message: data.message,
              });

            let visionState;

            if (data.severity === 'error') {
              visionState = data.previous_status || 'disabled';  
            } else {
              // ako je poruka success i prethodno stanje je disable_pending → sad treba biti disabled
              // ako je prethodno stanje enable_pending → sad je enabled
              const currentDevice = this.getSelectedDevice;
              if (currentDevice.vision_workers === 'disable_pending') {
                visionState = 'disabled';
              } else if (currentDevice.vision_workers === 'enable_pending') {
                visionState = 'enabled';
              } else {
                visionState = 'enabled'; // fallback ako nešto nije jasno
              }
            }
            
            this.$store.commit('devices/UPDATE_DEVICE_VISION_STATE', {
              uuid: data.deviceUuid,
              vision_workers: visionState
            });
          break;
          }
          case "visionDeviceToggleMessageReceivedNotification": {
            const current = this.getSelectedDevice.vision_workers;
            const nextState = current === 'enable_requested' ? 'enable_pending' : current === 'disable_requested' ? 'disable_pending' : null;
            this.$store.commit('devices/UPDATE_DEVICE_VISION_STATE', {
              uuid: data.deviceUuid,
              vision_workers: nextState
            });
            break;
          }
          case "visionDeviceOfflineModeMessageReceivedNotification": {
            const current = this.getSelectedDevice.vision_offline_mode;
            const nextState = current === 'offline_mode_enable_requested' ? 'offline_mode_enable_pending' : current === 'offline_mode_disable_requested' ? 'offline_mode_disable_pending' : null;
             this.$store.commit('devices/UPDATE_DEVICE_VISION_OFFLINE_STATE', {
              uuid: data.deviceUuid,
              vision_offline_mode: nextState
            });
            break;
          }

          case "visionDeviceOfflineModeEnabledStatusNotification": {
            this.addAlert({
                type: data.severity === 'error' ? 'error' : 'success',
                message: data.message,
              });
             let visionState;

            if (data.severity === 'error') {
              visionState = data.previous_status || 'offline_mode_disabled';  
            } else {
              // ako je poruka success i prethodno stanje je disable_pending → sad treba biti disabled
              // ako je prethodno stanje enable_pending → sad je enabled
              const currentDevice = this.getSelectedDevice;
              if (currentDevice.vision_offline_mode === 'offline_mode_disable_pending') {
                visionState = 'offline_mode_disabled';
              } else if (currentDevice.vision_offline_mode === 'offline_mode_enable_pending') {
                visionState = 'offline_mode_enabled';
              } else {
                visionState = 'offline_mode_enabled'; // fallback ako nešto nije jasno
              }
            }
            
            this.$store.commit('devices/UPDATE_DEVICE_VISION_OFFLINE_STATE', {
              uuid: data.deviceUuid,
              vision_offline_mode: visionState
            });
          break;
          }
          case "spaceDeviceHardwareConfiguratorNotification":
            this.addAlert({
              type: data.severity === "error" ? "error" : "success",
              message: data.message,
            }).then(() => {
              this.$store.commit("devices/SET_LOADER_CONFTOOL", false);
            });
            break;
          case "spaceDeviceTouchscreenCalibrationNotification":
            this.addAlert({
              type: data.severity === "error" ? "error" : "success",
              message: data.message,
            }).then(() => {
              this.$store.commit("devices/SET_LOADER_TOUCHSCREENCALIBRATION", false);
            });
            break;
          case "spaceDeviceDebugEnabledStatusNotification":
          case "spaceDeviceDebugDisabledStatusNotification":
            this.handleDeviceDebugStatusNotification(data);
            break;
          }
        });
      }

    },
  selectItem(route, type, uuid) {
      if (route === 'location' || 
          route === 'device' ||  
          route === 'device_location' || 
          route === 'performance' || 
          route === 'activity' || 
          route === 'group') {
        if (route === 'location' && this.$route.params.tab === 'general') {
          this.getLocation(uuid);
        } else if(route === 'device_location') {
          let data = {
            route: 'device',
            space_uuid: this.$route.params.space_uuid,
            uuid: this.$route.params.uuid
          }
          this.setSpace(data.space_uuid);
          this.subscribe('device', this.$route.params.uuid);
          this.getDevice(data);
        }else if(route === 'performance'){
          let data = {
            route: 'device',
            space_uuid: this.$route.params.space_uuid,
            uuid: this.$route.params.uuid
          }
          this.setSpace(data.space_uuid);
          this.subscribe(data.route, data.uuid);
          this.getDevice(data)
        }
        else if(route === 'activity'){
          let data = {
            route: 'device',
            space_uuid: this.$route.params.space_uuid,
            uuid: this.$route.params.uuid
          }
          this.setSpace(data.space_uuid);
          this.subscribe(data.route, data.uuid);
          this.getDevice(data)
        }
        else if(route === "device"){
          let data = {
            route: 'device',
            space_uuid: this.$route.params.space_uuid,
            uuid: this.$route.params.uuid
          }
          this.setSpace(data.space_uuid);
          this.subscribe(data.route, data.uuid);
          this.getDevice(data)

        }
        else if(route === "group"){
          this.fetchGroup(this.$route.params.uuid);
        }
      }
    },
  },
  created() {
    const {device_type, action, uuid, location_type, monitoring_type} = this.$route.params;
    const mainCategory = this.$route.name;
    this.route = mainCategory;
    this.type = device_type || 
                location_type || 
                monitoring_type;
    switch (mainCategory) {
      case "location":
        switch (action) {
          case "view":
            if (this.$route.params.uuid.toUpperCase().match(v4) || 
                this.$route.params.uuid.toUpperCase().match(v5) || 
                this.$route.params.uuid) {
              this.selectItem(mainCategory, location_type, uuid)
            }
            break;
        }
        break;
      case "device":
        switch (action) {
          case "view":
            this.selectItem(mainCategory, device_type, uuid)
            break;
        }
        break;
      case "device_location":
        switch (action) {
          case "view":
            this.selectItem(mainCategory, device_type, uuid)
            break;
        }
        break;
        case "performance":
          switch(action){
            case "view":
              this.selectItem(mainCategory, monitoring_type, uuid)
              break;
        }
        break;
        case "activity":
        switch(action){
            case "view":
              this.selectItem(mainCategory, device_type, uuid)
              break;
        }
        break;
        case "group":
        switch(action){
            case "view":
              this.selectItem(mainCategory, this.$route.params.uuid)
              break;
        }
        break;
      case "activity_device":
        switch(action){
          case "view":
            this.selectItem('activity', device_type, uuid)
            break;
        }
        break;
      case "performance_device":
        switch(action){
          case "view":
            this.selectItem('performance', monitoring_type, uuid)
            break;
        }
        break;
    }
  },
  // beforeDestroy() {
  // this.closeDialog();
  // },
  // created() {
  //   this.type = this.$route.params.type;
  //   this.route = this.$route.name
  //   console.log(this.route)
  //   switch (this.route) {
  //     case "location":
  //       switch (this.type) {
  //         case "view":
  //           if (this.$route.params.uuid.toUpperCase().match(v4) || this.$route.params.uuid.toUpperCase().match(v5)) {
  //             this.selectItem(this.route, this.$route.params.type, this.$route.params.uuid)
  //           }
  //           break;
  //         case "edit":
  //           console.log("dosao edit")
  //           break;
  //       }
  //       break;
  //     case "device":
  //       switch (this.type) {
  //         case "view":
  //           if (this.$route.params.uuid.toUpperCase().match(v4) || this.$route.params.uuid.toUpperCase().match(v5)) {
  //             this.selectItem(this.route, this.$route.params.type, this.$route.params.uuid)
  //           }
  //           break;
  //       }
  //   }
  //   // if (
  //   //   this.$route.params.type &&
  //   //   this.$route.params.uuid &&
  //   //   (this.$route.params.uuid.toUpperCase().match(v4) || this.$route.params.uuid.toUpperCase().match(v5))
  //   // ) {
  //   //   this.selectItem(this.$route.params.type, this.$route.params.uuid);
  //   // }
  // },
  watch: {
    $route() {
      const {type, action, uuid} = this.$route.params;
      const mainCategory = this.$route.name;
      this.route = mainCategory;
      this.type = type;
      switch (mainCategory) {
        case "location":
          switch (action) {
            case "view":
              if (this.$route.params.uuid.toUpperCase().match(v4) || 
                  this.$route.params.uuid.toUpperCase().match(v5) || 
                  this.$route.params.uuid) {
                this.selectItem(mainCategory, action, uuid)
              }
              break;
          }
          break;
        case "device":
          switch (action) {
            case "view":
              if (uuid !== this.getSelectedDevice?.uuid) {
                this.selectItem(mainCategory, action, uuid)
              }
              break;
          }
          break;
        case "device_location":
          switch (action) {
            case "view":
              if (uuid !== this.getSelectedDevice?.uuid) {
                this.selectItem(mainCategory, action, uuid)
              }
              break;
          }
          break;
          case "performance":
          switch(action){
            case "view":
            if (uuid !== this.getSelectedDevice?.uuid) {
                this.selectItem(mainCategory, action, uuid)
              }
              break;
          }
          break;
          case "activity":
          switch(action){
            case "view":
            if (uuid !== this.getSelectedDevice?.uuid) {
                this.selectItem(mainCategory, action, uuid)
              }
              break;
          }
          break;
          case "group":
          switch(action){
            case "view":
                this.selectItem(mainCategory, action, uuid);
              break;
          }
          break;
        case "activity_device":
          switch(action){
            case "view":
              if (uuid !== this.getSelectedDevice?.uuid) {
                this.selectItem('activity', type, uuid)
              }
              break;
          }
          break;
        case "performance_device":
          switch(action){
            case "view":
              if (uuid !== this.getSelectedDevice?.uuid) {
                this.selectItem('performance', type, uuid)
              }
              break;
          }
          break;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-dialog--scrollable {
    position: absolute;
    right: 0;
    margin: 0;
    border-radius: 0;
  }

  .v-dialog:not(.v-dialog--fullscreen) {
    min-height: 100%;
    box-shadow: none;
  }
}

.mr-sm-15 {
  margin-right: 64px;
}

@media screen and (max-width: 600px) {
  .mr-sm-15 {
    margin-right: 0 !important;
  }
}
.overlay-dark{
  background-color: #757575 !important;
}
</style>
